import React, { useState } from "react";
import {
  Form,
  Row,
  Col,
  Button,
  Card,
} from "react-bootstrap";
import {
  FiCamera,
  FiUpload,
} from "react-icons/fi";



export default function ProfileTab() {
  const [image, setImage] = useState(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];

    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);

      // Save image in localStorage
      localStorage.setItem("profileImage", imageUrl);
    }
  };

  return (
    <div className="profile-wrapper">
      <Card className="profile-card border-0">
        <Card.Body>
          {/* Header */}
          <div className="mb-4">
            <h4 className="profile-title">Profile Settings</h4>
          </div>

          {/* Basic Information */}
          <div className="section-title">
            <h6>Basic Information</h6>
          </div>

          {/* Upload Box */}
          <div className="upload-container">
            <div className="upload-left">
              <div className="upload-avatar">
                {image ? (
                  <img src={image} alt="profile" />
                ) : (
                  <FiCamera />
                )}
              </div>

              <div className="upload-content">
                <h6>Profile Photo</h6>
                <p>Recommended image size is 40px x 40px</p>

                <div className="upload-buttons">
                  <label className="upload-btn">
                    <FiUpload className="me-1" />
                    Upload
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={handleImageUpload}
                    />
                  </label>

                  <button
                    type="button"
                    className="cancel-btn"
                    onClick={() => setImage(null)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <Form className="profile-form">
            <Row>
              <Col lg={6} md={6} sm={12}>
                <Form.Group className="mb-4">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control type="text" />
                </Form.Group>
              </Col>

              <Col lg={6} md={6} sm={12}>
                <Form.Group className="mb-4">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control type="text" />
                </Form.Group>
              </Col>

              <Col lg={6} md={6} sm={12}>
                <Form.Group className="mb-4">
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email" />
                </Form.Group>
              </Col>

              <Col lg={6} md={6} sm={12}>
                <Form.Group className="mb-4">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control type="text" />
                </Form.Group>
              </Col>
            </Row>

            <hr className="section-divider" />

            {/* Address Information */}
            <div className="section-title">
              <h6>Address Information</h6>
            </div>

            <Row>
              <Col lg={12}>
                <Form.Group className="mb-4">
                  <Form.Label>Address</Form.Label>
                  <Form.Control type="text" />
                </Form.Group>
              </Col>

              <Col lg={6} md={6} sm={12}>
                <Form.Group className="mb-4">
                  <Form.Label>Country</Form.Label>

                  <Form.Select>
                    <option>Select</option>
                    <option>India</option>
                    <option>USA</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col lg={6} md={6} sm={12}>
                <Form.Group className="mb-4">
                  <Form.Label>State</Form.Label>

                  <Form.Select>
                    <option>Select</option>
                    <option>Telangana</option>
                    <option>Andhra Pradesh</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col lg={6} md={6} sm={12}>
                <Form.Group className="mb-4">
                  <Form.Label>City</Form.Label>

                  <Form.Select>
                    <option>Select</option>
                    <option>Hyderabad</option>
                    <option>Vijayawada</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col lg={6} md={6} sm={12}>
                <Form.Group className="mb-4">
                  <Form.Label>Postal Code</Form.Label>
                  <Form.Control type="text" />
                </Form.Group>
              </Col>
            </Row>

            {/* Footer Buttons */}
            <div className="profile-footer">
              <Button variant="light" className="footer-cancel-btn">
                Cancel
              </Button>

              <Button className="footer-save-btn">
                Save
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
      <style>
        {
          `
          /* ProfileTab.css */

.profile-wrapper {
  // padding: 20px;
  // background: #f5f6fa;
  min-height: 100vh;
}

// .profile-card {
//   border-radius: 10px;
//   background: #fff;
//   border: 1px solid #e8e8e8 !important;
//   box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
// }

.profile-title {
  font-size: 19px;
  font-weight: 660;
  color: #232528;
  margin: 0;
}

.section-title h6 {
  font-size: 14px;
  font-weight: 660;
  margin-bottom: 18px;
  color: #111827;
}

.upload-container {
  border: 1px solid #ececec;
  border-radius: 8px;
  padding: 22px;
  background: #fafafa;
  margin-bottom: 30px;
}

.upload-left {
  display: flex;
  align-items: center;
  gap: 18px;
}

.upload-avatar {
  width: 82px;
  height: 82px;
  border-radius: 50%;
  border: 1px dashed #d6d6d6;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #fff;
  color: #b5b5b5;
  font-size: 24px;
}

.upload-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-content h6 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 5px;
  color: #111827;
}

.upload-content p {
  margin: 0;
  color: #6b7280;
  font-size: 13px;
}

.upload-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
}

.upload-btn {
  background: #ff6b1a;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}

.upload-btn:hover {
  background: #eb5d10;
}

.cancel-btn {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 500;
}

.profile-form .form-label {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}

.profile-form .form-control,
.profile-form .form-select {
  height: 48px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  box-shadow: none !important;
}

.profile-form .form-control:focus,
.profile-form .form-select:focus {
  border-color: #ff6b1a;
}

.section-divider {
  margin: 10px 0 25px;
  border-color: #ececec;
}

.profile-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}

.footer-cancel-btn {
  min-width: 100px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #ddd !important;
  font-weight: 600;
}

.footer-save-btn {
  min-width: 100px;
  height: 44px;
  border-radius: 8px;
  background: #ff6b1a !important;
  border: none !important;
  font-weight: 600;
}

.footer-save-btn:hover {
  background: #eb5d10 !important;
}

/* Mobile Responsive */

@media (max-width: 768px) {
  .profile-wrapper {
    padding: 12px;
  }

  .upload-left {
    flex-direction: column;
    align-items: flex-start;
  }

  .upload-buttons {
    flex-wrap: wrap;
  }

  .profile-footer {
    flex-direction: column;
  }

  .footer-cancel-btn,
  .footer-save-btn {
    width: 100%;
  }

  .profile-title {
    font-size: 20px;
  }
}`
        }
      </style>
    </div>
  );
}